// Confirmation sonore + vibration pour les scans en caisse (aucun asset requis).
let ctx;
export function beep(ok = true) {
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (AC) {
      ctx = ctx || new AC();
      if (ctx.state === "suspended") ctx.resume();
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.connect(g); g.connect(ctx.destination);
      o.type = "square";
      o.frequency.value = ok ? 880 : 200;
      const now = ctx.currentTime;
      const dur = ok ? 0.12 : 0.28;
      g.gain.setValueAtTime(0.0001, now);
      g.gain.exponentialRampToValueAtTime(0.18, now + 0.01);
      g.gain.exponentialRampToValueAtTime(0.0001, now + dur);
      o.start(now);
      o.stop(now + dur + 0.02);
    }
  } catch (e) { /* audio indisponible : on ignore */ }
  try { if (navigator.vibrate) navigator.vibrate(ok ? 40 : [60, 40, 60]); } catch (e) {}
}
